var map = {
	"./icons8-address-30.png": "6280",
	"./icons8-email-30.png": "024b",
	"./icons8-facebook-30.png": "507c",
	"./icons8-github-30.png": "740d",
	"./icons8-linkedin-30.png": "d565",
	"./icons8-project-30.png": "9dc7",
	"./icons8-stack-overflow-30.png": "8c7e",
	"./icons8-telephone-30.png": "6ed0",
	"./icons8-twitter-30.png": "bf9e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3929";